import { apiService } from '../../../shared/services/apiServices';
import equipmentEndpoints from './equipmentEndpoints';

export interface EquipmentCategoryItem {
  id: string;
  label: string;
}

interface ListCategoriesResponse {
  categories: EquipmentCategoryItem[];
  pagination: {
    page: number;
    limit: number;
    totalCount: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
}

export const listEquipmentCategories = async (params: {
  page: number;
  limit: number;
  search?: string;
  status?: string;
}): Promise<{ data: EquipmentCategoryItem[]; hasNextPage: boolean }> => {
  const query = new URLSearchParams({
    page: String(params.page),
    limit: String(params.limit),
    ...(params.search ? { search: params.search } : {}),
    ...(params.status ? { status: params.status } : {}),
  });

  const result = await apiService.getAPI(
    `${equipmentEndpoints.LIST_CATEGORIES}?${query}`
  );

  if (result.error) {
    return { data: [], hasNextPage: false };
  }

  const body = result.data as ListCategoriesResponse;
  return { data: body.categories, hasNextPage: body.pagination.hasNextPage };
};
